import request from 'superagent';
import { readable } from 'svelte/store';



function foldersTree(list) {
  var map = {}, node, roots = [], i;
  for (i = 0; i < list.length; i++) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
  }
  for (i = 0; i < list.length; i++) {
      node = list[i];
      if (node.parent_id && node.parent_id !== null) {
          // if you have dangling branches check that map[node.parentId] exists
          list[map[node.parent_id]].children.push(node);
      } else {
          roots.push(node);
      }
  }
  return roots;
}

export const my_documents = readable([], set => {
  setTimeout(() => {
    request.get('/my/e/documents.jsr')
    .then(function(r) {
      if (r.ok) return r.body.count == 1 ? [r.body.data] : r.body.data || [];
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(data => {
      set(foldersTree(data));
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
  }, 12*60)
});

export const my_folders = readable([], set => {
  setTimeout(() => {
    request.get('/my/e/folders.jsr')
    .then(function(r) {
      if (r.ok) return r.body.count == 1 ? [r.body.data] : r.body.data || [];
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(data => {
      set(foldersTree(data));
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
  }, 12*60)
});


